import { ColumnImporterSettings } from '@components/trace/column/column.importer.settings';
import { Separator } from '@components/ui/separator';

import type { AtomModel } from '@models/atom.model';

import type { TableImporterNumberColumnData } from '@stratumn/studio-shared';
import { NumberWidgetSettings } from '@widgets/number/number.widget.settings';

type Props = {
  atom: AtomModel<TableImporterNumberColumnData>;
};

export const NumberSettingsModal = ({ atom }: Props) => (
  <>
    <NumberWidgetSettings
      atomId={atom.id}
      onOptionsChange={v => (atom.data.cell.view.format.options = v)}
      options={atom.data.cell.view.format.options}
    />
    <Separator />
    <ColumnImporterSettings
      columnName={atom.data.title}
      from={atom.data.importerOptions.from}
      onFromChange={v => (atom.data.importerOptions.from = v)}
    />
    <Separator />
  </>
);
